<template lang="pug">
  div(:class="{ 'has-error': !valid, 'form-group': true }")
    .vfl-field.input-group(style='width: 100%;')
      input(type="text",
        required="",
        :class="numberClass",
        :value="value",
        @input="$emit('input', $event.target.value)"
      )
      span.field-underline
      label {{ label }}

    span.help-block.error(v-if="!valid") {{ message }}
</template>

<script>
    import InputMask from 'inputmask/dist/inputmask/inputmask';
    import uuid4 from 'uuid/v4';

    export default {
        name: 'NumberInput',

        props: {
            value: {
                type: String
            },
            label: {
                type: String
            },

            valid: {
                type: Boolean,
                default: true
            },
            message: {
                type: String,
                default: ''
            },

            // Возможное количество знаков после запятой
            precision: {
                type: Number,
                default: 0
            }
        },

        mounted() {
            let regex = '\\d{0,15}';
            if (this.precision) {
                regex += `[.]{1}\\d{0,${this.precision}}`;
            }

            const fields = document.getElementsByClassName(this.className);
            InputMask({ regex, placeholder: '' }).mask(fields);
        },

        data() {
            const className = `number-${uuid4().slice(0, 5)}`;
            return {
                className,
                numberClass: {
                    [ className ]: true
                }
            };
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/fields/NumberInput.vue